// extracted by mini-css-extract-plugin
export default {"container":"m2CRhPrWU5yBGJmCiImI"};